// Minimal inline SVG icon set (24x24 viewBox, stroke-based, matches Lucide styling).
// Each entry is the inner markup of an <svg> element.
export const ICONS = {
  compass:
    '<circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/>',
  arrowUpRight: '<path d="M7 7h10v10"/><path d="M7 17 17 7"/>',
  cornerDownLeft: '<polyline points="9 10 4 15 9 20"/><path d="M20 4v7a4 4 0 0 1-4 4H4"/>',
  chevronLeft: '<path d="m15 18-6-6 6-6"/>',
  lifeBuoy:
    '<circle cx="12" cy="12" r="10"/><path d="m4.93 4.93 4.24 4.24"/><path d="m14.83 9.17 4.24-4.24"/><path d="m14.83 14.83 4.24 4.24"/><path d="m9.17 14.83-4.24 4.24"/><circle cx="12" cy="12" r="4"/>',
};

export default {
  name: 'SvgIcon',
  functional: true,
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 16 },
    color: { type: String, default: 'currentColor' },
  },
  render(h, { props }) {
    return h('svg', {
      attrs: {
        width: props.size,
        height: props.size,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: props.color,
        'stroke-width': 2,
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'aria-hidden': 'true',
      },
      domProps: { innerHTML: ICONS[props.name] || '' },
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/manager/icons.js